import { useLayoutEffect, useRef } from 'react';
import { shallowEqual } from '@core/helpers/shallowEqual';
function useShallowCompareMemoize(value) {
    const ref = useRef();
    if (!shallowEqual(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
/** useEffect but shallow compares items in the dependency list. */
export function useShallowCompareLayoutEffect(callback, dependencies) {
    // This needs to be a useLayoutEffect instead of useEffect because it is used
    // to rebind event handlers in VideoComponent and must therefore happen before
    // the browser paints. See https://fwn.atlassian.net/browse/GROW-1168
    //
    // This special setup doesn't work well with the exhaustive-deps eslint check.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useLayoutEffect(callback, dependencies.map(useShallowCompareMemoize));
}
